import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CloudProviderContext, shouldShowAzurePlaceholderView } from "../../CloudProviderContext";
import { useDispatch, useSelector } from 'react-redux';
import { Router, Switch, Route, useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import {
  getLicensingData,
  getListOfAccts,
  pushNotification,
  getProfileRoleInfo,
  getListOfOrgsAndAccts,
  getListAccRules,
  getListAllRules,
} from '../../store/actions';
import AccountsConfig from './_accountsConfig';
import UsersConfig from './_usersConfig';
import SecurityConfig from './_securityConfig';
import ResourceGroupsConfig from "./_resourceGroupsConfig";
import Suppression from './Suppression';
import InaccessibleResources from '../../helpers/InaccessibleResources';
import OfflineCur from "../OfflineCur";

const freeLicenseName = process.env.REACT_APP_FREE_ORGANIZATION_LICENSE;
const freeLicenses = [freeLicenseName];

const AZURE_DISABLED_TAB_STYLE = {
  opacity: 0.5,
  filter: "blur(1px)",
  pointerEvents: "none",
  cursor: "not-allowed",
};

const Configuration = ({ licenseName }) => {
  const { selectedProvider } = useContext(CloudProviderContext);
  const isAzureView = useMemo(
    () => shouldShowAzurePlaceholderView(selectedProvider),
    [selectedProvider]
  );
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(
      getListOfAccts({
        params: { accountType: selectedProvider },
      })
    );
  }, [selectedProvider, dispatch]);

    console.log("Configuration page, licenseName: " , licenseName);
  const defaultRoutes = [
    {
      displayName: "Cloud Accounts",
      component: AccountsConfig,
      navLink: "/configuration/accounts",
    },
    {
      displayName: "Users",
      component: UsersConfig,
      navLink: "/configuration/users",
    },
    // {
    //   displayName: "Security",
    //   component: freeLicenses.includes(licenseName)? InaccessibleResources : SecurityConfig,
    //   navLink: "/configuration/security",
    // },
    {
      displayName: "Resource Groups",
      component: freeLicenses.includes(licenseName)? InaccessibleResources : ResourceGroupsConfig,
      navLink: "/configuration/resourcegroups",
    },
    {
      displayName: "Compliance Configuration",
      component: freeLicenses.includes(licenseName)? InaccessibleResources : Suppression,
      navLink: "/configuration/suppression",
    },
    {
      displayName: "Upload CUR2.0",
      component: OfflineCur,
      navLink: "/configuration/offline-cur",
    },
  ];
  const visibleRoutes = defaultRoutes.filter(
    (route) => !(isAzureView && route.navLink === "/configuration/offline-cur")
  );
  const [mask, setMask] = useState(false);
  const [configRoutes, setConfigRoutes] = useState();
  const [contactForAsistance, setContactForAsistance] = useState(false);
  const [isCustomer, setIsCustomer] = useState(false);
  const licensing = useSelector((state) => state.licensing);
  const notifications = useSelector((state) => state.notify);
  const acctList = useSelector((state) => state.acctList);
  const orgAccount = useSelector((state) => state.orgAccount);
  const { data, costLookup, status } = licensing;

    useEffect(() => {
        // Check if customer is true in selectedOrganization
        const selectedOrganizationStr = localStorage.getItem('selectedOrganization');
        if (selectedOrganizationStr) {
            try {
                const selectedOrganization = JSON.parse(selectedOrganizationStr);
                setIsCustomer(selectedOrganization.customer === true);
            } catch (error) {
                console.error('Error parsing selectedOrganization:', error);
            }
        }

        if (!licensing?.data && !licensing?.loading && !licensing?.error) {
            dispatch(getLicensingData());
        }
        // if (!acctList?.accounts && !acctList?.loading) {
        //     dispatch(getListOfAccts());
        // }

        // console.log("Calling getProfileRoleInfo() from configuration.index#useEffect");
        // dispatch(getProfileRoleInfo());
        if ((!orgAccount?.accounts || !orgAccount?.organizations?.length) && !orgAccount?.loading) {
            dispatch(getListOfOrgsAndAccts());
        }
    }, []);
    useEffect(() => {
        if (licensing && licensing.data && licensing.data.numAccounts && acctList && acctList.accounts) {
            const numAccounts = licensing.data.numAccounts;
            const accountNotification = {message: `${acctList.accounts.length -1}/${numAccounts}`, 
            fullmessage:`Accounts ${acctList.accounts.length -1} of ${numAccounts} Used`,
            amend: false};
            if (acctList.accounts.length-1 < numAccounts) {
                accountNotification.className="badge badge-outline bg-white border border-secondary"
            } else if (acctList.accounts.length >= numAccounts) {
                accountNotification.className="badge-mine"
            }
            dispatch(pushNotification(accountNotification));

            const numUsers = licensing.data.numUsers;
            const temp = [];
            acctList.accounts.forEach((item) => {
                item.listusr.forEach((entity) => temp.push(entity))
            });
            const usersNotification = {message: `${acctList.usersConfig.length}/${numUsers}`, 
            fullmessage:`Users ${acctList.usersConfig.length} of ${numUsers} Used`,
            amend: true};
            if (acctList.usersConfig.length < numUsers) {
                usersNotification.className="badge badge-outline bg-white border border-secondary"
            } else if (acctList.usersConfig.length >= numUsers) {
                usersNotification.className = "badge-mine"
            }
            dispatch(pushNotification(usersNotification));
        }
    }, [licensing, acctList])

    useEffect(() => {
        const updatedRoutes = [];
        visibleRoutes.forEach((item) => {
            // Check if current path matches the route or is a sub-route
            const isActive = location.pathname === item.navLink || 
                           (item.navLink !== "/configuration/accounts" && 
                            location.pathname.startsWith(item.navLink));
            const isDisabled = isAzureView && item.navLink === "/configuration/suppression";
            updatedRoutes.push({
                displayName: item.displayName,
                navLink: item.navLink,
                isActive: isActive,
                isDisabled,
            })
        });
        setConfigRoutes(updatedRoutes);
    }, [location, isAzureView])

    useEffect(() => {
        if (!isAzureView) return;
        if (
            location.pathname.startsWith("/configuration/offline-cur") ||
            location.pathname.startsWith("/configuration/suppression")
        ) {
            history.replace("/configuration/accounts");
        }
    }, [isAzureView, location.pathname, history]);

    useEffect(() => {
        
        if (data && !data.isLicensingComplete && data.licenseName === "NONE") {
            console.log("data is here ", data)
            setMask(true)
            setContactForAsistance(true)
        } else {
            setMask(false);
        }
    }, [data])

    const handleRedirectLink = (e) => {
        const isDirty = sessionStorage.getItem('isDirty', 'true');
        const targetLink = e.target.getAttribute('link');
        console.log('--== targetLink ', targetLink);
        if (targetLink && !isDirty) {
            e.preventDefault();
            e.stopPropagation();
            history.push(targetLink)
        }
    }

    // If customer is true, show only UsersConfig without tabs
    if (isCustomer) {
        return (
            <React.Fragment>
                <div className="page-content" style={{backgroundColor: '#fff'}}>
                    <Container fluid>
                        <Card className={mask ? "mask" : ""}>
                            <CardBody>
                                <UsersConfig />
                                <Modal isOpen={contactForAsistance}>
                                    <ModalBody>
                                        <div className="form-check">
                                            <label className="form-check-label" htmlFor="agreeTerms">
                                                Licensing must be completed before any changes can be made.
                                            </label>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button type="button" className="btn btn-secondary" onClick={() => setContactForAsistance(false)}>OK</button>
                                    </ModalFooter>
                                </Modal>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{backgroundColor: '#fff'}}>
                <Container fluid>
                    <Card className={mask ? "mask" : ""}>
                        <CardBody>
                            <Row>
                                <Col xs={8}>
                                    {
                                        configRoutes && (
                                            <ul className="nav nav-pills" style={{
                                                display: 'inline-flex',
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '8px',
                                                padding: '4px',
                                                gap: '4px',
                                                margin: 0
                                            }}>
                                                {
                                                    configRoutes.map((item, index) => {
                                                        return (
                                                            <li key={index} className="nav-item" style={{ margin: 0 }}>
                                                                <button
                                                                    onClick={item.isDisabled ? undefined : handleRedirectLink}
                                                                    link={item.isDisabled ? undefined : item.navLink}
                                                                    disabled={item.isDisabled}
                                                                    className={`btn btn-sm nav-link ${item.isActive ? 'active' : ''}`}
                                                                    style={{
                                                                        borderRadius: '6px',
                                                                        margin: 0,
                                                                        fontWeight: '500',
                                                                        ...(item.isDisabled ? AZURE_DISABLED_TAB_STYLE : {}),
                                                                    }}
                                                                >
                                                                    {item.displayName}
                                                                </button>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <hr />
                                    <div className="mt-1"></div>
                                    <Switch>
                                        {
                                            visibleRoutes.map((item) => {
                                                return (
                                                    <Route key={item.navLink} path={item.navLink} component={item.component} />
                                                )
                                            })
                                        }
                                    </Switch>
                                </Col>
                            </Row>
                            <Modal isOpen={contactForAsistance}>
                                <ModalBody>
                                    <div className="form-check">
                                        <label className="form-check-label" htmlFor="agreeTerms">
                                            Licensing must be completed before any changes can be made.
                                        </label>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <button type="button" className="btn btn-secondary" onClick={() => setContactForAsistance(false)}>OK</button>
                                </ModalFooter>
                            </Modal>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}


export default Configuration;